<!--
<section id="" class="content-padding">
    <div class="narrow-wrapper">
        <form class="has-cols" [formGroup]="timingForm" (ngSubmit)="onSubmit()" >
            <div class="delivery-colle-data-box">
                <fieldset>
                    <legend>APPROVED TIMINGS:</legend>

                    <div class="col-48 grid-element">
                        <label>PICK UP TIME SLOT</label>
                        
                        <div class="time-range" [ngClass]="{'hidden': delivery?.isFlexblePickUpTime}">
                            <div>
                                <select formControlName="pickUpTime" [attr.disabled]="true">
                                    <option value="06:00-07:00">06:00-07:00</option>
                                    <option value="07:00-08:00">07:00-08:00</option>
                                    <option value="08:00-09:00">08:00-09:00</option>
                                    <option value="09:00-10:00">09:00-10:00</option>
                                    <option value="10:00-11:00">10:00-11:00</option>
                                    <option value="11:00-12:00">11:00-12:00</option>
                                    <option value="12:00-13:00">12:00-13:00</option>
                                    <option value="13:00-14:00">13:00-14:00</option>
                                    <option value="14:00-15:00">14:00-15:00</option>
                                    <option value="15:00-16:00">15:00-16:00</option>
                                    <option value="16:00-17:00">16:00-17:00</option>
                                    <option value="17:00-18:00">17:00-18:00</option>
                                    <option value="18:00-19:00">18:00-19:00</option>
                                    <option value="19:00-20:00">19:00-20:00</option>
                                    <option value="20:00-21:00">20:00-21:00</option>
                                    <option value="21:00-22:00">21:00-22:00</option>
                                </select>
                            </div>
                        </div>
                        
                        <div class="time-range" [ngClass]="{'hidden': !delivery?.isFlexblePickUpTime}">
                            <div>
                                <input type="time" [attr.disabled]="true">
                                <div *ngIf="pickUpTTimeError" style="color: red; font-size: small;">Obbligatorio</div>
                            </div>
                            <div style="text-align: center;">&nbsp;-&nbsp;</div>
                            <div>
                                <input type="time" [attr.disabled]="true">
                                <div *ngIf="pickUpTTimeError" style="color: red; font-size: small;">Obbligatorio</div>
                            </div>
                        </div>
                    </div>
                    <br class="clear">
                    <div class="col-48 grid-element">
                        <label>Check For Approved Uncheck For Not Approved</label>
                        <label class="original-label">
                            <input 
                                type="checkbox" 
                                formControlName="approvedTimingStatus"
                                (change)="onCheckboxChange()"
                            />
                            APPROVED STATUS 
                        </label>
                    </div>

                    <div class="col-48 grid-element" *ngIf="!timingForm.get('approvedTimingStatus').value">
                        <label>New PICK UP TIME SLOT</label>

                        <div class="time-range" [ngClass]="{'hidden': delivery?.isFlexblePickUpTime}">
                            <div>
                                <select formControlName="newPickUpTime">
                                    <option value="06:00-07:00">06:00-07:00</option>
                                    <option value="07:00-08:00">07:00-08:00</option>
                                    <option value="08:00-09:00">08:00-09:00</option>
                                    <option value="09:00-10:00">09:00-10:00</option>
                                    <option value="10:00-11:00">10:00-11:00</option>
                                    <option value="11:00-12:00">11:00-12:00</option>
                                    <option value="12:00-13:00">12:00-13:00</option>
                                    <option value="13:00-14:00">13:00-14:00</option>
                                    <option value="14:00-15:00">14:00-15:00</option>
                                    <option value="15:00-16:00">15:00-16:00</option>
                                    <option value="16:00-17:00">16:00-17:00</option>
                                    <option value="17:00-18:00">17:00-18:00</option>
                                    <option value="18:00-19:00">18:00-19:00</option>
                                    <option value="19:00-20:00">19:00-20:00</option>
                                    <option value="20:00-21:00">20:00-21:00</option>
                                    <option value="21:00-22:00">21:00-22:00</option>
                                </select>
                                <div *ngIf="timingForm.get('newPickUpTime').hasError('required') && timingForm.get('newPickUpTime').touched" style="color: red; font-size: small;">Obbligatorio</div>
                            </div>
                        </div>
                        
                        <div class="time-range" [ngClass]="{'hidden': !delivery?.isFlexblePickUpTime}">
                            <div>
                                <input type="time" [(ngModel)]="pickUpFTime" [ngModelOptions]="{standalone: true}" (ngModelChange)="handlePickUpFlexbleTime()">
                                <div *ngIf="pickUpTTimeError" style="color: red; font-size: small;">Obbligatorio</div>
                            </div>
                            <div style="text-align: center;">&nbsp;-&nbsp;</div>
                            <div>
                                <input type="time" [(ngModel)]="pickUpTTime" [ngModelOptions]="{standalone: true}" (ngModelChange)="handlePickUpFlexbleTime()">
                                <div *ngIf="pickUpTTimeError" style="color: red; font-size: small;">Obbligatorio</div>
                            </div>
                        </div>
                    </div>

                </fieldset>
            </div>
            <div class="center mt-20">
                <button 
                    class="btn hvr-shrink center" 
                    (click)="$event.preventDefault(); onSubmit()"
                    [disabled]="btnDisabled || !timingForm.valid">
                    Salva
                    <i class="ml-10 far fa-save"></i>
                </button>
            </div>
        </form>
    </div>
</section>
-->

<section id="" class="content-padding">
    <div class="narrow-wrapper">
        <form class="has-cols" [formGroup]="valetStartEndTimeForm" *ngIf="valetStartEndTimeForm" (ngSubmit)="onSubmit()">
            <div class="delivery-colle-data-box">
                <fieldset>
                    <legend>Start and End Time:</legend>

                    <div class="col-48 grid-element" >
                        <label>START TIME AND END TIME</label>
                        <div class="time-range">
                            <div>
                                <input type="time" formControlName="valetStartTime">
                                <!-- <div style="color: red; font-size: small;">Obbligatorio</div> -->
                            </div>
                            <div style="text-align: center;">&nbsp;-&nbsp;</div>
                            <div>
                                <input type="time" formControlName="valetEndTime">
                                <!-- <div style="color: red; font-size: small;">Obbligatorio</div> -->
                            </div>
                        </div>
                    </div>

                    <!--
                    <div class="grid-element-full">
                        <div class="signature-wrapper">
                            <h3 class="signature-title">Per favore firma qui sotto</h3>
                            <div class="signature-card">
                                <div class="sign">
                                    <signature-pad
                                    *ngIf="!delivery?.receiverSign"
                                    [options]="signaturePadOptions"
                                    (onEnd)="drawComplete()">
                                    </signature-pad>
                                    <img [src]="delivery?.receiverSign" alt="">
                                </div>
                                <div class="signature-actions">
                                    <button type="button" *ngIf="!delivery?.receiverSign" class="btn clear-btn" [disabled]="disabledBtn" (click)="clear()">Clear</button>
                                    <button type="button" *ngIf="delivery?.receiverSign" class="btn clear-btn" [disabled]="disabledBtn" (click)="deleteSignature()">Remove Sign</button>
                                    <button type="button" *ngIf="!delivery?.receiverSign" class="btn save-btn" [disabled]="disabledBtn" (click)="$event.preventDefault(); save();">Save</button>
                                </div>
                            </div>
                        </div>
                    </div>
                    -->
                </fieldset>
            </div>
            <div class="center mt-20">
                <button 
                    class="btn hvr-shrink center" 
                    (click)="$event.preventDefault(); onSubmit()"
                    [disabled]="!valetStartEndTimeForm.valid || btnDisabled || disabledBtn">
                    Salva
                    <i class="ml-10 far fa-save"></i>
                </button>
            </div>
        </form>
    </div>
</section>